import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import { Container as ContainerBase, ContentWithPaddingXl } from "components/misc/Layouts";
import { SectionDescription } from "components/misc/Typography";

const Container = tw(ContainerBase)`bg-primary-900 text-gray-100 -mx-8 px-8`;
const HeadingContainer = tw.div``;
const Heading = tw(SectionHeading)`sm:text-3xl md:text-4xl lg:text-5xl`;
const Subheading = tw(SubheadingBase)`text-gray-500 text-center`;
const Description = tw(SectionDescription)`text-gray-400 text-center mx-auto max-w-screen-lg`;

export default ({
  subheading = "Versione Rewind: BETA",
  heading = "Vuoi darci una mano?",
  description = "La nostra gamemode è attualmente in fase beta e subisce rapidamente modifiche di varia entità. Se vuoi contribuire allo sviluppo, puoi condividere i tuoi suggerimenti nel canale #suggerimenti del nostro discord oppure candidarti come tester contattando @crossover#7865."
}) => {
  return (
    <Container>
      <ContentWithPaddingXl>
        <HeadingContainer>
          {subheading && <Subheading>{subheading}</Subheading>}
          <Heading>{heading}</Heading>
          {description && <Description>{description}</Description>}
        </HeadingContainer>
      </ContentWithPaddingXl>
    </Container>
  );
};
